module.exports = __webpack_public_path__ + "static/img/ket-renewal-pc-sub-page-01@t.a9ba2f0.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/ket-renewal/ket-renewal-pc-sub-page-01@t.png
// module id = 6AZQ
// module chunks = 0